import React from "react";
import { Box, Typography } from "@mui/material";
import { C, PaletteTone } from "./palette";

// Shared Staff Portal KPI card. Extracted from MessageTemplates.tsx
// where the same visual (icon tile + big number + label + helper) is
// used. ParentRequests.tsx is the second consumer — see memory
// "Hoist shared primitive on second module".
export interface KpiCardProps {
  label: string;
  value: React.ReactNode;
  helper?: string;
  tone: PaletteTone;
  Icon: React.ElementType;
  loading?: boolean;
}

export const KpiCard: React.FC<KpiCardProps> = ({ label, value, helper, tone, Icon, loading }) => {
  const t = C[tone];
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        borderRadius: "14px",
        p: { xs: 1.5, md: 2 },
        border: "1px solid rgba(15,23,42,0.06)",
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        minHeight: 82,
        transition: "box-shadow 160ms ease, transform 160ms ease",
        "&:hover": {
          boxShadow: "0 6px 18px rgba(15,23,42,0.08)",
          transform: "translateY(-1px)",
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: "10px",
          bgcolor: t.bg,
          color: t.fg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 22,
            fontWeight: 800,
            color: t.fg,
            lineHeight: 1,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {loading ? "—" : value}
        </Typography>
        <Typography
          sx={{
            fontSize: 10.5,
            fontWeight: 800,
            letterSpacing: "0.5px",
            color: C.navy.fg,
            textTransform: "uppercase",
            mt: 0.5,
          }}
        >
          {label}
        </Typography>
        {helper && (
          <Typography sx={{ fontSize: 11, color: "text.secondary" }}>
            {helper}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default KpiCard;
